module.exports = " <div class=\"weui_panel weui_panel_access\"> <div class=weui_panel_hd v-if=\"header && header.title\" v-html=header.title @click=\"$emit('on-click-header')\"></div> <slot name=header></slot> <div class=weui_panel_bd> <div class=vux-card-content><slot name=content></slot></div> </div> <a class=weui_panel_ft href=javascript: v-if=\"footer && footer.title\" v-html=footer.title @click=onClickFooter></a> <slot name=footer></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/card/index.vue
// module id = 207
// module chunks = 2